function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 356.3 304.7"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round"
}, React.createElement("g", {
  strokeLinejoin: "round",
  strokeWidth: "4.5"
}, React.createElement("path", {
  d: "M293.5 181.4c-.2 58.5-47.7 105.8-106.2 105.7-57.3-.2-104-45.8-105.6-103v-2.6C81 122.9 128 75 186.5 74.4s106.4 46.4 107 104.9v2.1z"
}), React.createElement("circle", {
  cx: "218.3",
  cy: "212.1",
  r: "35.6"
}), React.createElement("path", {
  d: "M253.6 207.6a35.67 35.67 0 0 1-39.9 30.8 35.74 35.74 0 0 1-30.1-27c-.6-2.7-.7-.9-.7-3.8m-87.5-76.4c16.3-2.9 31.9 8.1 34.7 24.4A30.03 30.03 0 0 1 81.5 184m189.3-67.2a20.94 20.94 0 0 1-27.4 11.1 20.94 20.94 0 0 1-11.1-27.4c1.9-4.4 5.1-8 9.3-10.3"
}), React.createElement("path", {
  d: "M81.6 176.5s7.5 10.4 28.8 4.9c20.3-5.3 17.1-34.2 17.1-34.2m103.3-35.6s19.9 22.6 38.7 2.8"
})), React.createElement("g", {
  strokeWidth: "3.5",
  strokeMiterlimit: "10"
}, React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: "5",
  d: "M188 91.2V4.8s16.3-7.3 26.8 4.2c11 12.1 35.5-4.4 35.5-4.4l.5 29s-16.8 16.2-41.8.8c0 0-11.2-5.8-20.4 2m-14.5 59.9c3 4 8.1 7.5 14 7.5s11-3.5 14-7.5"
}), React.createElement("path", {
  d: "M56.5 49.6l4.3 4.3m-10.9 5.6h7.8M56.4 70l4.3-4.3m6.4 10v-7.8m0-17.3v-7.8M77.9 70l-4.3-4.3m11.3-6.2h-7.8m.9-9.9l-4.3 4.3M9.5 275.6l4.3 4.3m-10.9 5.6h7.8M9.4 296l4.3-4.3m6.4 10v-7.8m0-17.3v-7.8M30.9 296l-4.3-4.3m11.3-6.2h-7.8m.9-9.9l-4.3 4.3M312.5 258.6l4.3 4.3m-10.9 5.6h7.8m-1.3 10.5l4.3-4.3m6.4 10v-7.8m0-17.3v-7.8m10.8 27.2l-4.3-4.3m11.3-6.2h-7.8m.9-9.9l-4.3 4.3M325.5 44.6l4.3 4.3m-10.9 5.6h7.8M325.4 65l4.3-4.3m6.4 10v-7.8m0-17.3v-7.8M346.9 65l-4.3-4.3m11.3-6.2h-7.8m.9-9.9l-4.3 4.3"
})))));